import frFlag from "../../../../img/frFlag.png?width=50px";
import FlagOptionBase from "../../abstracts/flagOptionBase";
import flagItemModal from "./flagItem";

export default class FrFlagOpt extends FlagOptionBase{
    private static titleLegend = "Françoise";
    private static idOption = "op-fr";
    private static elementToRender = flagItemModal(frFlag,FrFlagOpt.titleLegend);

    constructor(protected modalBody:HTMLElement){
        super(modalBody,FrFlagOpt.idOption,FrFlagOpt.elementToRender);
    }

    translateAction(){
        localStorage.setItem("i18n","fr");
    }
}